import { Link } from "react-router-dom";
import { useSeo } from "../hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "Page Not Found | The Law Office of Ronald K. Nolen, LLC",
    description: "The page you are looking for could not be found.",
    path: "/404",
  });
  return (
    <section className="flex min-h-[70vh] items-center justify-center bg-warmwhite px-5 pt-24" data-testid="not-found">
      <div className="text-center">
        <p className="font-serif text-7xl font-500 text-gold">404</p>
        <h1 className="mt-4 font-serif text-4xl font-500 text-navy">Page Not Found</h1>
        <p className="mx-auto mt-4 max-w-md text-bluegray-text">
          The page you are looking for could not be found or may have moved.
        </p>
        <Link to="/" data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center rounded-sm bg-navy px-8 py-4 text-sm font-600 text-white transition-colors hover:bg-navy-light">
          Return Home
        </Link>
      </div>
    </section>
  );
}
